export const IS_WEB = ![typeof window, typeof document].includes("undefined");